import React from 'react';
import { addClient } from '../../../../data/serviceClients';
import AccordianTitle from '../../../../helpers/uiComponents/Accordian';
import { ActionTabs } from '../../../../helpers/uiComponents/ActionTabs';
import { InputRow } from '../../../../helpers/uiComponents/InputRow';
import { hideMessage, showMessage } from '../../../../helpers/uiFunctions/uiActions';
import { franchiseList } from '../../../../helpers/uiFunctions/uiHelpers';

class Franchise extends React.Component {
    constructor(props) {
		super(props);
		// console.log(props);
		this.state = {
			franchiseeList: [],
		}
		this.save = this.save.bind(this);
		this.assign = this.assign.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
	}

	componentDidMount() {
		var clients = this.props.clients.filter( client => { return client.status !== "archived" && client.franchisee === true; });
		let list = [];
		for (var i = 0; i < clients.length; i++) {
			list.push({"name": clients[i].name, "value": clients[i].clientCode,},)
		}
		this.setState({
			franchiseeList: list,
		});
	}
	handleUpdate(e) {
		var key = e.target.name;
		var value = e.target.value;
		var subArr = null;

		if (key.includes(".")) {
			subArr = key.split('.')[0];
			key = key.split('.')[1];
		}

		var type = e.target.type;
		if (type === "checkbox") {
			value = e.target.checked
		}
		var updateClient = this.props.updateClient
        updateClient(key, value, subArr);
	}
    save() {
		showMessage("Saving Franchise...");
		var client = this.props.currentClient;
		delete client.transactions;
		addClient(this.props.currentClient).then(data => {
			hideMessage(data.success);
			var getClient = this.props.getClient;
			getClient(this.props.currentClient.clientCode);
		});
	}
    isAssigned(clientCode, clientList) {
		var checked = false;
		if (clientList.includes(clientCode)) {
			checked = true;
		}
		return checked;
	}
	assign(e) {
		var clientCode = e.target.id;
		var franchisees = this.props.currentClient.franchisees;
		var checked = e.target.checked
		console.log(checked)
		
		if (checked) { franchisees.push(clientCode); }
		else {franchisees = franchisees.filter(cc => { return cc !== clientCode });}
		console.log(clientCode, franchisees);
		
		var updateClient = this.props.updateClient
        updateClient("franchisees", franchisees);
	}

    render() {
        const currentClient = this.props.currentClient;
		const {franchiseeList} = this.state
		//console.log(franchiseeList);
		
		return (
			<div className="input-group">
				<AccordianTitle title={"Franchise Management"} />
				<div className="accordian-body">
					<ActionTabs
						id={"franchise"}
						handleSave={this.save}
					/>
					{(currentClient) && (
						<div id="franchise-inputs" className="inputs">
                            <InputRow
								onChange={this.handleUpdate}
								label="Franchise Name"
								type="select"
								value={currentClient.franchiseName}
								property="franchiseName"
								id="franchiseName"
								options={franchiseList}  
							/>
							<em>This input will add this client to the list of franchisees below.</em>
							<br/>
							<em>Leave empty if this client is a franchisor (parent), or this client is not part of a franchise.</em>
							<InputRow
								onChange={this.handleUpdate}
								label="Client is a FRANCHISEE (child)?"
								type="checkbox"
								value={currentClient.franchisee}
								property="franchisee"
							/>
                            {(!currentClient.franchisee) && (
                                <React.Fragment>
                                    <h5>Select Franchisees</h5>
									<em>Do not select any franchisees if this client is not part of a franchise.</em>
                                    <div id={"franchisee-list"}>
                                        <ul className="promo-clientList">
                                            {franchiseeList.map(franchisee =>
                                                <li key={franchisee.value}>
                                                    <input type="checkbox" id={franchisee.value} onChange={this.assign} defaultChecked={this.isAssigned(franchisee.value, currentClient.franchisees)} />
                                                    <span>{franchisee.name}</span>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </React.Fragment>
                            )}
						</div>
					)}
				</div>
			</div>
		)
    }
}
export default Franchise;


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/Franchise.js